import { inject, Injectable } from '@angular/core';
import { Views } from '../custom-classes/View';
import { RouterService } from './router.service';
import { BehaviorSubject} from 'rxjs';
import { MenuConfig, MenuItem, MenuSection, MenuState } from '../types/menu.types';
import { RolesEnum } from '../enums/RolesEnum';
import { PermissionsEnum } from '../enums/PermissionsEnum';
import { ViewPath } from '../constants/ViewPath';
import { UserService } from './user.service';
import { MENU_ITEMS } from '../constants/MenuItems';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  private menuConfig = new BehaviorSubject<MenuConfig | null>(null);
  private menuState = new BehaviorSubject<MenuState>({
      isOpen: true,
      expandedSections: new Set<string>(),
      isLocked: false
  });

  // Constructor inyeccion de dependencias
  routerS = inject(RouterService);
  userS = inject(UserService);

  // Cargar configuración del menú (desde API, local, etc.)
  loadMenuConfig(config: MenuConfig): void {
      this.menuConfig.next(config);
  }

  // Obtener menú filtrado por permisos
  getFilteredMenu(): MenuItemInterface | undefined {
      let v = ViewPath;
      // let vehiculos = new MenuOption("Vehículos", "wheel", "Vehiculos", "car", v.vehicles, [], [v.createvehicle, v.vehicleDetails], undefined, "onboarding-vehicle");
      //let productos = new MenuOption("Productos", "barcode_scanner", "Productos", "car", v.products, [], [v.createProduct, v.discountGroups, v.productDetails, v.tarifasTable, v.tarifaToStock, v.tarifasImport], undefined, "onboarding-product");
      // let filteredMenu = new MenuMultipleOption("Gestión", "car", "car", [vehiculos, productos], v.abono, [PermissionsEnum.ALL]);
      return undefined; //filteredMenu;
      /*return this.menuConfig.pipe(
          filter(config => config !== null),
          map(config => this.filterMenuByPermissions(config!))
      );*/
  }


  buildMenuByPermissions(userPermissions: PermissionsEnum[]) : MenuOption[]
  {
    //Lista de todos los puntos de menu y filtrar por permisos del usuario.
    let menuOptions : MenuOption[] = [];
    let menuItems = MENU_ITEMS;
    menuItems.forEach((menuItem) => {
      menuItem.requiredPermissions.forEach((permission) => {
        if(userPermissions.includes(permission)) {
          menuOptions.push(
            new MenuOption(
              menuItem.id,
              menuItem.name,
              menuItem.label,
              menuItem.icon,
              menuItem.view,
              [permission],
              [menuItem.view],
              undefined,
              undefined
            )
          );
        }
      });
    });

    console.log("menuOptions", menuOptions);
    return menuOptions;
  }


  private sectionIsVisible(section: MenuSection, userRoles: RolesEnum[]): boolean {
        if (!section.roles) return true;
        return section.roles.some(role => userRoles.includes(role));
  }

  /*private filterSectionItems(
    items: Array<MenuItem | MenuOption>, 
    userRoles: RolesEnum[], 
    userPermissions: string[]
  ): MenuItem[] {
      const filteredItems = items
          .filter(item => this.itemIsVisible(item, userRoles, userPermissions))
          .map(item => {
              const menuItem = item as MenuItem;
              const filteredChildren = menuItem.children 
                  ? this.filterSectionItems(menuItem.children, userRoles, userPermissions)
                  : undefined;

              return {
                  ...menuItem,
                  children: filteredChildren
              };
          })
          // Filtrar items que no tienen hijos válidos
          .filter(item => {
              const hasValidChildren = item.children && item.children.length > 0;
              const isValidParent = item.route || item.action || item.view;
              
              return hasValidChildren || isValidParent;
          });

      return filteredItems;
  }*/

  private itemIsVisible(
      item: MenuItem, 
      userRoles: RolesEnum[], 
      userPermissions: PermissionsEnum[]
  ): boolean {
      // Verificar roles
      if (item.roles && !item.roles.some(role => userRoles.includes(role))) {
          return false;
      }
      
      // Verificar permisos específicos
      if (item.requiredPermissions && !item.requiredPermissions.every(perm => userPermissions.includes(perm))) {
          return false;
      }
      
      // Verificar visibilidad explícita
      return item.visible !== false;
  }

  // Gestión del estado del menú (abierto/cerrado, items expandidos)
  toggleMenu(): void {
      const currentState = this.menuState.value;
      this.menuState.next({
          ...currentState,
          isOpen: !currentState.isOpen
      });
  }

  toggleItemExpansion(itemId: string): void {
      const currentState = this.menuState.value;
      const expandedItems = new Set(currentState.expandedSections);
      
      if (expandedItems.has(itemId)) {
          expandedItems.delete(itemId);
      } else {
          expandedItems.add(itemId);
      }
      
      this.menuState.next({
          ...currentState,
          //expandedSections
      });
  }

  // Navegación
  navigateTo(item: MenuItem): void {
      if (item.route) {
          this.routerS.goTo(item.view);
      } else if (item.action) {
          item.action();
      }
  }



  havePermisisons(view: Views): boolean {
    return this.routerS.userCanGo(view);
  }




  //LEGACYYYY
  isSelected(data: MenuItemInterface) {
    if (data.viewsSelected != undefined) {
      return this.routerS.is(...data.viewsSelected) || this.routerS.is(data.view);
    }
    else {
      return this.routerS.is(data.view);
    }
  }

  /** MUTIPLE */


  /** Mira si alguno de los hijos esta seleccionado */
  isSelectedMultiple(children: MenuOption[]) {
    if (children) {
      for (let i = 0; i < children.length; i++) {
        if (this.isSelected(children[i])) {
          return true;
        }
      }
    }
    return false;
  }

  /** Mira si alguno de los hijos tiene permisos 
   * Si ninnguno de los hijos tiene permisos, ocultamos el componente
  */
  childsHasPermission(children: MenuOption[]) {
    if (!children) { return false; }
    
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      const hasRolePermission = this.havePermisisons(child.view);
      
      if (!hasRolePermission) { continue; }
      
      const hasEnumPermission = 
        child.requiredPermissions.length === 0 ||
        this.userS.permisssions.includes(PermissionsEnum.ALL) ||
        this.userS.hasAnyPermission(child.requiredPermissions, this.userS.permisssions);
      
      if (hasEnumPermission) { return true; }
    }
    
    return false;
  }
}


export interface MenuItemInterface {

  name: string;
  selected?: boolean;

  /** Metadata */
  id: string;
  label: string;
  icon?: string;
  route?: string;
  action?: () => void;
  children?: MenuOption[];
  roles?: RolesEnum[]; // Roles que pueden ver este item
  dashboards?: string[]; // Dashboards específicos donde aparece
  visible?: boolean;
  order?: number;
  view: Views;
  viewsSelected?: Views[];

  /** Backend */
  requiredRole?: RolesEnum[];
  requiredPermissions: PermissionsEnum[]; // Permisos requeridos (ej: 'users.read.list')

  /** UI */
  class_?: string;
  isExpanded?: boolean;
  badge?: {
      count: number;
      color?: string;
  };
}


/**Datos para generar el componente de dropDown
* @param name : Título de la sección
* @param child : Array de dropDownChilds (subsecciones)
* @param isSelected : Boolean que defini si esta seleccionado o no
*/
export class MenuMultipleOption implements MenuItemInterface {
  id: string;
  name: string;
  label: string;
  children: MenuOption[];
  selected = false;
  requiredPermissions: PermissionsEnum[];
  view: Views;
  constructor(id: string, name: string, label: string, children: MenuOption[], view: Views, permissions: PermissionsEnum[]) {
    this.id = id;
    this.label = label;
    this.name = name;
    this.children = children;
    this.requiredPermissions = permissions;
    this.view = view;
  }
}


/** ------------------------------------------------------------- */

/**
* Hijos del componente de MenuMultipleOption
* @param name : Título de la sección
* @param icon : Icono de la sección
* @param view : Vista a la que redirige la sección
* @param isSelected : Array de views que determinana si la sección esta seleccionada. Por defecto, la view a a la que redirige (@param - view) se incluye en esta array.
* @param buttonAction : Acción al hacer click en el botón
*/
export class MenuOption implements MenuItemInterface {
  id: string;
  name: string;
  label: string;
  icon: string;
  view: Views;
  viewsSelected?: Views[];
  selected: boolean = false;
  class_?: string;
  requiredPermissions: PermissionsEnum[];
  constructor(id: string, name: string, label: string, icon: string, view: Views, permissions: PermissionsEnum[], viewsSelected?: Views[], action?: () => void, class_?: string) {
    this.id = id;
    this.name = name;
    this.label = label;
    this.icon = icon;
    this.view = view;
    this.viewsSelected = viewsSelected;
    this.class_ = class_;
    this.requiredPermissions = permissions;
  }
}


/** ------------------------------------------------------------- */
export interface MenuInterface {
  afterGoTo: () => void
  open(): void;
  toggle(): void;
  toggleTo(opened: boolean): void;
}
